export interface ICalculatorParameters {
  lowerBound: number;
  constantValue: number;

  computeValue(volume: number): number;
}

export interface ICalculator {
  compute(volume: number): number;
}

/**
 * used by estimateLeakRate method
 * when total volume > 2500 and type = TYPEIV
 */

export class BigVolumeCalculator implements ICalculator {
  compute(volume: number): number {
    return 8.533 * Math.exp(-0.0001266 * volume) + 12.03 * Math.exp(-3.433e-6 * volume);
  }
}
/**
 * used by estimateLeakRate method
 * when total volume <= 2500
 */
export class LowerBoundCalculator implements ICalculator {
  constructor(private parameters: ICalculatorParameters) {}

  compute(volume: number): number {
    if (volume < this.parameters.lowerBound) {
      return this.parameters.constantValue;
    }
    return this.parameters.computeValue(volume);
  }
}
